import Vue from 'vue'
import isDarkColor from 'is-dark-color'

Vue.prototype.$isDarkColor = isDarkColor
